module.exports = __webpack_public_path__ + "img/new_act.ecc58e5e.png";